import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js';
import axios from 'axios';
import Loading from './img/loading.gif';
import validator from 'validator';
import {Loader} from './Loader.js';

import {SocialAuth} from './SocialAuth.js';

const RegRequestNotSent =  (props) => {
    
    return <>
        
        <div><h1>Регистрация</h1></div>
          <Loader loader={props.isSending} />
          {/*<SocialAuth />*/}
          <div className="uk-margin">
              <input className={
                  props.emailError === null 
                  ?
                  "uk-input uk-form-width-large uk-form-large uk-background-muted "  
                  :
                  "uk-input uk-form-width-large uk-form-large uk-background-muted error_input"  
              } 
              type="text" onChange={e => props.updateEmailValue(e)}  placeholder="Email*" value={props.email} />
              <div className='input_error'>{props.emailError}</div>          
          </div>
          <div className="uk-margin">
              <input className={
                  props.passwordError === null 
                  ?
                  "uk-input uk-form-width-large uk-form-large uk-background-muted "  
                  :
                  "uk-input uk-form-width-large uk-form-large uk-background-muted error_input"  
              } 
              type="password" onChange={e => props.updatePasswordValue(e)}
               value={props.password}  placeholder="Пароль*"/>
               <div className='input_error'>{props.passwordError}</div>  
          </div>
          <div className="main-left-bottom">
              <div className="uk-flex">
                  <div><p>Уже есть аккаунт ?</p></div>
                  <div style={{fontWeight: 'bold', marginLeft: '10px'}}><a href='/auth'>Войти</a></div>
              </div>
              <div className="uk-flex">
                  <div>
                      <input onChange={e => props.updateChecked(e)} checked={props.agreed} className="uk-checkbox" type="checkbox" />
                  
                  </div>
                  <div className="uk-text-left uk-margin-small-left"><p>Регистрируясь в сервисе вы соглашаетесь
                      с политикой конфиденциальности 
                      и условиями пользования</p></div>
              </div>
              <button onClick={e => props.SendRegisterRequest(e)} 
              className="btn1">Зарегистрироваться</button>
          </div>

    </>
}

export class Reg extends Component {
    
    state = {
        email :'',
        password : '',
        agreed : false,
        isSending : false,
        hasSentRegRequest : false,
        emailError: null,
        passwordError: null,
        errorMsg: null,
        showErrorMsg: false 
    }

    constructor(props) {
        super(props)
        this.props = props 
    }

    // Функция для получения куки по имени
    getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    updateEmailValue = (e) => {
        const updatedInputValue = e.target.value;
        
        this.setState((prevState) => {
             return  {
                    email : updatedInputValue,
                    emailError: null
                };
        }, () =>  {
            
        })
    
    }

    updatePasswordValue = (e) => {
        
        const updatedInputValue = e.target.value;        
        this.setState((prevState) => {
             return  {
                    password : updatedInputValue,
                    passwordError: null 
                };
        }, () =>  {
            
        })

    }

    updateChecked = (e) => {

        this.setState((prevState) => {
            return  {
                agreed : !prevState.agreed
               
               };
       }, () =>  {
           
       })


    }

    msgTimer = 2000
    
    doShowErrorMsg(msg) {
        
        this.setState((prevState) => {
            return  {
                ...prevState,
                isSending : false,
                errorMsg : msg,
                showErrorMsg : true
               };
        })
        setTimeout(() => { 
            this.setState((prevState) => {
                return  {
                    ...prevState,
                    isSending : false,
                    errorMsg : null,
                    showErrorMsg : false
                   };
            })
           
        }, this.msgTimer)
    }


    SendRegisterRequest = (e) => {
        e.preventDefault()
        var emailError = null
        if ( !validator.isEmail(this.state.email) ) {
            emailError = "Введите корректный email"
        }

        var passwordError = null
        if ( !validator.isStrongPassword(this.state.password, {
            minLength: 8,  minNumbers: 0, minSymbols: 0, minLowercase: 0, minUppercase: 0
          }) ) {
            passwordError = "Пароль должен содержать не менее 8 символов"
        }
        
        
        if (emailError !== null || passwordError !== null) {

            this.setState((prevState) => {
                return  {
                    isSending : false,
                    emailError : emailError,
                    passwordError : passwordError
                   };
           }, () =>  {
               
           })

           return
        }
        
        if (this.state.agreed) {

            e.preventDefault();
            this.setState({isSending : true})
            
            // Получаем referral_id из куки
            const referralId = this.getCookie('referral_id');
            
            // Получаем UTM метку
            var qs = require('qs');
            var utm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).utm
            
            if (!utm) {
                utm = 'empty'
            }
            
            // Формируем данные для отправки
            const requestData = {
                'email' : this.state.email,
                'password' : this.state.password,
                'utm' : utm
            };
            
            // Добавляем referral_id если он есть
            if (referralId) {
                requestData.referral_code = referralId;
            }
            
            axios
            .post('https://api.clickanti.ru/api/users/register/', requestData)
            .then(res => {
                // Проверяем успешность регистрации
                if (res.status === 201 && res.data.message) {
                    // Сохраняем токены в localStorage (опционально)
                    if (res.data.tokens) {
                        localStorage.setItem('access_token', res.data.tokens.access);
                        localStorage.setItem('refresh_token', res.data.tokens.refresh);
                    }
                    
                    this.setState({hasSentRegRequest: true, isSending:false})
                } else {
                    this.setState({isSending:false}, () => {
                        this.doShowErrorMsg("Ошибка регистрации")
                    })
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({isSending:false}, () => {
                    // Обработка ошибок от бекенда
                    if (err.response && err.response.data) {
                        // Если бекенд вернул конкретные ошибки валидации
                        const errors = err.response.data;
                        let errorMessage = '';
                        
                        if (errors.email) {
                            errorMessage = Array.isArray(errors.email) ? errors.email[0] : errors.email;
                            this.setState({emailError: errorMessage});
                        }
                        if (errors.password) {
                            errorMessage = Array.isArray(errors.password) ? errors.password[0] : errors.password;
                            this.setState({passwordError: errorMessage});
                        }
                        if (errors.non_field_errors) {
                            errorMessage = Array.isArray(errors.non_field_errors) ? errors.non_field_errors[0] : errors.non_field_errors;
                        }
                        
                        if (errorMessage) {
                            this.doShowErrorMsg(errorMessage);
                        } else {
                            this.doShowErrorMsg("Ошибка при регистрации");
                        }
                    } else {
                        this.doShowErrorMsg("Ошибка соединения с сервером");
                    }
                })
            })
           
        }
        else {
            this.doShowErrorMsg("Поставьте галочку")
        }

    }

    render() {
        return (
            
            <RegWrapper showErrorMsg={this.state.showErrorMsg}
            errorMsg={this.state.errorMsg}>
            { this.state.hasSentRegRequest ? 
            <div>
                <h1>
                    Проверьте email для подтверждения регистрации. 
                    Письмо могло попасть в папку спам. 
                    Если письмо не пришло в течение 1 минуты, 
                     <a href={process.env.REACT_APP_SUPPORT_LINK}> напишите в тех. поддержку </a>
                </h1>
            </div>
            :
            <RegRequestNotSent
            isSending={this.state.isSending}
            passwordError = {this.state.passwordError}
            emailError = {this.state.emailError} 
            updateEmailValue={this.updateEmailValue} 
            updatePasswordValue={this.updatePasswordValue} 
            password={this.state.password}
             email={this.state.email} updateChecked={this.updateChecked}
              agreed={this.state.agreed} 
              SendRegisterRequest={this.SendRegisterRequest}/> }
            
      
        </RegWrapper>  

        )
    }

}